module.exports = __webpack_public_path__ + "static/media/images-6-zpHwG1NffPmuU1ry9iBpXMs2bIeJEP.75339763.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/images-6-zpHwG1NffPmuU1ry9iBpXMs2bIeJEP.webp
// module id = 640
// module chunks = 0